var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M28.724 9.473c.02.282.02.564.02.848 0 8.675-6.605 18.679-18.68 18.679v-.005A18.6 18.6 0 0 1 0 26.052q.779.093 1.563.095c2.956.002 5.828-.99 8.153-2.816a6.57 6.57 0 0 1-6.133-4.559c.984.19 1.998.151 2.964-.113a6.565 6.565 0 0 1-5.266-6.434v-.084c.912.509 1.934.79 2.98.822a6.573 6.573 0 0 1-2.033-8.765 18.63 18.63 0 0 0 13.53 6.858 6.573 6.573 0 0 1 11.188-5.987c1.471-.29 2.88-.83 4.17-1.594a6.6 6.6 0 0 1-2.886 3.63A13 13 0 0 0 32 6.072a13.3 13.3 0 0 1-3.276 3.4"
  })));
};
export default SvgTwitter;